// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'house-bed';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M3.938 13.387a1.688 1.688 0 1 0 3.375 0 1.688 1.688 0 0 0-3.376 0zM9 11.7h4.688a1.5 1.5 0 0 1 1.5 1.5v1.875H9z' />
    <path d='M9 15.074H2.812v2.25m12.376-2.25v2.25m0-12.75V9.45m-12.375 0V4.573M.563 6.075 8.375.865a1.125 1.125 0 0 1 1.248 0l7.814 5.21' />
  </g>
);

export const viewBox = '0 0 18 18';
